<template>
  <div id="app">
    <site-nav />
    <site-header />
    <router-view />
  </div>
</template>

<style lang="scss">
  
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }


  body {
    background-color: #DEDEDE;
  }

  * {
    box-sizing: border-box;
  }

  a,
  a:visited,
  a:hover,
  a:active {
    text-decoration: none;
    color: inherit;
  }

</style>

<script>
  import SiteNav from '@/components/SiteNav.vue'
  import SiteHeader from '@/components/SiteHeader.vue'

  export default {
    name: 'BothSides',

    components: {
      SiteNav, SiteHeader
    },

    methods: {
      cleanupNetlifyHiddenForm() {
        document.querySelector('#suggest-form-hidden').remove()
      }
    },

    mounted() {
      this.cleanupNetlifyHiddenForm()
    }
  }
</script>
